import React from 'react';
import './ShipmentDetails.css';

export default function ShipmentDetails({ shipment, packing_list, loading = false }) {
  if (loading) {
    return <div className="shipment-details-block"><p>Loading shipment details...</p></div>;
  }

  if (!shipment) {
    return <div className="shipment-details-block"><p>No shipment details available</p></div>;
  }

  // Get supplier name from packing_list if available
  const supplier_name = packing_list?.supplier?.supplier_name || 'N/A';
  const order_number = packing_list?.order_number || 'N/A';
  const invoice_number = packing_list?.invoice_number || 'N/A';

  return (
    <div className="shipment-details-block">
      <h3>Shipment Details</h3>
      
      <div className="details-grid">
        <div className="detail-item">
          <label>Shesha Reference</label>
          <span>{shipment.shesha_reference || 'N/A'}</span>
        </div>

        <div className="detail-item">
          <label>Client Name</label>
          <span>{shipment.client_name || 'N/A'}</span>
        </div>

        <div className="detail-item">
          <label>Delivery Address</label>
          <span className="address-span">{shipment.delivery_address || 'N/A'}</span>
        </div>

        <div className="detail-item">
          <label>SFR Number</label>
          <span>{shipment.sfr_number || 'N/A'}</span>
        </div>

        <div className="detail-item">
          <label>Bill of Lading</label>
          <span>{shipment.bill_of_lading || 'N/A'}</span>
        </div>

        <div className="detail-item">
          <label>Vessel/Voyage Number</label>
          <span>{shipment.vessel_voyage_number || 'N/A'}</span>
        </div>

        <div className="detail-item">
          <label>Supplier Name</label>
          <span>{supplier_name}</span>
        </div>

        <div className="detail-item">
          <label>Order Number</label>
          <span>{order_number}</span>
        </div>

        <div className="detail-item">
          <label>Invoice Number</label>
          <span>{invoice_number}</span>
        </div>

        <div className="detail-item">
          <label>Client PO Number</label>
          <span>{packing_list?.client_po_number || 'N/A'}</span>
        </div>
      </div>
    </div>
  );
}
